<div class="h-100 d-flex flex-column justify-content-between">
  <div class="py-1 pl-2 d-flex flex-row justify-content-between modal-header">
    Building {{ buildingIds.join(", ") }}
    <i class="pr-2 fa fa-times" role="button" (click)="onCloseModal()"></i>
  </div>
  <div class="kml-viewer-modal-content" style="height: calc(100% - 36px)">
    <fes-path-kml-viewer
      #path3d
      [waypointPaths]="paths"
      [pathIds]="selectedPathIds"
      [overlaysByPathId]="overlaysByPathId"
      (close)="onCloseModal()"
    ></fes-path-kml-viewer>
  </div>
</div>
